import { isValidWebAppLocale } from '~/utils/guards/isValidWebAppLocale';
import { useGeoinformationStore } from '~/stores/geoinformationStore/geoinformationStore';
import type { EntryWithLinkData, IContentPage } from '~/lib/ContentfulService';
import { StatusCodes } from 'http-status-codes';

export default defineNuxtRouteMiddleware(async (to) => {
  if (
    to.path === '/' ||
    [
      'lighting-advisor',
      'assets',
      'fonts',
      'images',
      'videos',
      'favicon',
      'api',
      'auth',
      '_nuxt',
      '.well-known'
    ].some((partialPath) => to.path.replace(/^\//, '').startsWith(partialPath))
  ) {
    return;
  }

  const locale = to.params.locale as string;

  if (!isValidWebAppLocale(locale)) {
    if (locale === 'cn') {
      return enhancedNavigateTo(
        {
          path: '/zh-cn/',
          query: to.query
        },
        {
          external: true
        }
      );
    }

    const store = useGeoinformationStore();
    const detectedLocale = (await store.ensureRedirectLocale()) ?? 'en';

    if (detectedLocale) {
      const notFoundPage = await $fetch<EntryWithLinkData<IContentPage>>(
        '/api/contentful/errorPage',
        {
          ...DEFAULT_FETCH_OPTIONS,
          query: { locale: detectedLocale, statusCode: StatusCodes.NOT_FOUND }
        }
      );

      const slug = notFoundPage.entry?.fields?.slug;
      if (slug) {
        return enhancedNavigateTo(
          {
            path: `/${convertContentfulToWebappLocaleCode(
              detectedLocale
            )}/${slug}/`,
            query: to.query
          },
          {
            external: true
          }
        );
      }
    }

    return enhancedNavigateTo(
      {
        path: `/${
          detectedLocale
            ? convertContentfulToWebappLocaleCode(detectedLocale)
            : 'en'
        }/`,
        query: to.query
      },
      {
        external: true
      }
    );
  }
});
